// Пилот переделанной таблицы метрик на экране аналитики (строки — метрики по отделам,
// колонки — дни недели, ограничитель и решение). Пока включён только для Вологды
// (city_id = 184, студии 497 / 599 / 642), остальные города видят классическую таблицу.
// ⚠️ Хардкод во фронте: в БД признака пилота нет.
// Когда пилот раскатают на сеть — удалить и функцию, и развилку в DailyPeriodMetricsTable.
const WEEKLY_DEPARTMENT_TABLE_CITY_IDS = new Set([184])
const WEEKLY_DEPARTMENT_TABLE_CITY_NAMES = new Set(['вологда'])

export interface StudioCityRef {
  cityId?: number | null
  cityName?: string | null
}

function isWeeklyDepartmentTableCity(city: StudioCityRef): boolean {
  if (city.cityId !== null && city.cityId !== undefined && city.cityId !== 0) {
    return WEEKLY_DEPARTMENT_TABLE_CITY_IDS.has(city.cityId)
  }
  const name = (city.cityName || '').trim().toLowerCase()
  return name.length > 0 && WEEKLY_DEPARTMENT_TABLE_CITY_NAMES.has(name)
}

/**
 * Переделанная таблица показывается, только если ВСЕ студии выборки — из пилотного
 * города. Смешанная выборка (сводная по нескольким городам) остаётся на классической
 * таблице: иначе франчайзи других городов увидели бы пилот через сводный экран.
 */
export function isWeeklyDepartmentTableEnabled(cities: StudioCityRef[]): boolean {
  if (cities.length === 0) return false
  return cities.every(isWeeklyDepartmentTableCity)
}
